import { useEffect, useState } from "react"
import Header from "../components/Header"
import { fetchMembersByQuery } from "../contexts/fetchMemberData"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { FullNamePlainTxt, TypeName } from "../components/MemberComp"

const imgHeight = '160px'

const PageMembers = () => {
    
    const [pi, setPI] = useState()
    const [rfs, setRfs] = useState([])
    const [phds, setPhds] = useState([])
    const [alumnis, setAlumnis] = useState([])
    const [visitors, setVisitors] = useState([])
    const [ilt, setIlt] = useState([])
    
    const navigate = useNavigate()

    useEffect(() => {
        return () => {
            setAlumnis([])
            setVisitors([])
            setPhds([])
            setRfs([])
            setPI()
            setIlt([])
        }
    }, [])


    useEffect(() => {
        const fetchMemberData = async () => {
            // const json = await fetchMembers();
            // setPhds(json.filter(m => m.type === 'PhD').sort((a, b) => a.sorting > b.sorting ? 1 : -1))
            // setRfs(json.filter(m => m.type === 'RF').sort((a, b) => a.sorting > b.sorting ? 1 : -1))
            // setAlumnis(json.filter(m => m.type === 'alumni'))
            // setVisitors(json.filter(m => m.type === 'visitor'))
            // setPI(json.filter(m => m.type === 'PI')[0])
            await fetchMembersByQuery(0, setPI).then(() => setPI(data => data[0]));
            await fetchMembersByQuery(1, setRfs);
            await fetchMembersByQuery(2, setPhds);
            await fetchMembersByQuery(3, setAlumnis);
            await fetchMembersByQuery(4, setVisitors);
            await fetchMembersByQuery(5, setIlt);
        }
        
        fetchMemberData()
    }, [])

    const PIData = props => {
        return pi && (
            <>
                <Row>
                    <Col className="d-none d-md-block" md='2' />
                    <Col xs='4' md='2'>
                        <img alt='' src={pi?.img || `${process.env.PUBLIC_URL}/memberPic/0/0.jpg`} style={{maxWidth: '100%', maxHeight: '200px'}}/>
                    </Col>
                    <Col xs='8' md='6'>
                        <h5>{pi.title} {pi.lastname?.toUpperCase()} {pi.firstname}</h5>
                        <div>{pi.ownlanguage}</div>
                        <ul>{pi.fields?.map((f, i) => (
                            <li key={i}>{f}</li>
                        ))}</ul>
                        <div className="text-end">
                            <Button variant="dark" size="sm"
                                onClick={() => navigate(`/member/${pi.firstname?.toLowerCase()}_${pi.lastname?.toLowerCase()}`)}>more</Button>
                        </div>
                    </Col>
                    <Col className="d-none d-md-block" md='2' />
                </Row>
                
                <br />
            </>
        )
    }

    const MappingData = props => {
        const { data } = props
        return data?.filter(m => !m.hidden).map((member, index) => (
            <Col sm='12' md='6' key={index} hidden={member?.hidden || false}>
                <Row>
                    <Col xs='3'>
                        <img 
                            alt='' 
                            src={member?.img || `${process.env.PUBLIC_URL}/memberPic/${member.type}/${member.index}.jpg`} 
                            onError={e => {
                                e.target.onerror = null;
                                e.target.src = `${process.env.PUBLIC_URL}/icons/profile.png`
                            }} 
                            style={{maxWidth: '100%', maxHeight: imgHeight}}
                        />
                    </Col>
                    <Col xs='8' className="d-flex flex-column">
                        <h5>{FullNamePlainTxt(member)}</h5>
                        <div className="text-bold">{member.shortDescription}</div>
                        <div>{member?.ownlanguage}</div>
                        {/* <div hidden>{member.ownlanguage}&nbsp;&nbsp;<span>{FlagIcons[member?.nationality]}</span></div> */}
                        {member?.type <= 2 ? (<>
                            <ul>{member.fields?.map((f, i) => (
                                <li key={i}>{f}</li>
                            ))}</ul>
                            <div className="text-end mt-auto">
                                <Button 
                                    variant="dark" size="sm"
                                    onClick={() => navigate(`/member/${member.firstname.toLowerCase()}_${member.lastname.toLowerCase()}`)}
                                >more</Button>
                            </div>
                        </>) : (
                            <div hidden={!(member?.email && member?.email?.length)}>
                                <img alt='' src={`${process.env.PUBLIC_URL}/icons/email.png`} style={{width: '32px'}} />{member?.email[0]}
                            </div>
                        )}
                    </Col>
                </Row>
                
                <br />
            </Col>
        ))
    }

    return (
        <div>
            <Header />
            <Container >
            <br />
                <div className="main-comp">
                    <h4>Principal Investigator</h4>
                    <hr />
                    <PIData />
                    
                </div>
                <br />
                {[rfs, phds, alumnis, visitors, ilt].map((data, index) => (
                    <div key={index} className="main-comp mb-4" hidden={!data.length}>
                        <h4>{TypeName[index + 1]}</h4>
                        <hr />
                        <Row>
                            <MappingData data={data} />
                        </Row>
                    </div>
                ))}
                <br />
            </Container>
            
        </div>
    )
}

export default PageMembers